var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatAlt8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.1323C2 8.19323 5.13401 5 9 5H15C18.866 5 22 8.19323 22 12.1323C22 17.5644 16.7364 20.7172 13.2248 21.9481C12.6096 22.1637 12 21.6791 12 21.0163V19.2646H9C5.13401 19.2646 2 16.0713 2 12.1323ZM8 13.1512C8.55228 13.1512 9 12.695 9 12.1323C9 11.5696 8.55228 11.1134 8 11.1134C7.44772 11.1134 7 11.5696 7 12.1323C7 12.695 7.44772 13.1512 8 13.1512ZM13 12.1323C13 11.5696 12.5523 11.1134 12 11.1134C11.4477 11.1134 11 11.5696 11 12.1323C11 12.695 11.4477 13.1512 12 13.1512C12.5523 13.1512 13 12.695 13 12.1323ZM16 13.1512C16.5523 13.1512 17 12.695 17 12.1323C17 11.5696 16.5523 11.1134 16 11.1134C15.4477 11.1134 15 11.5696 15 12.1323C15 12.695 15.4477 13.1512 16 13.1512Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAlt8);
export default __webpack_public_path__ + "static/media/chat-alt-8.8d5f57ddc8e0260071b80ab59a104900.svg";
export { ForwardRef as ReactComponent };